import { atom } from "jotai";
import { Events, PublicationEvents } from "../services/publicationEvents";

export const publicationEventsAtom = atom<PublicationEvents | undefined>(undefined);

export const getEvents = <K extends keyof Events>(key: K, atom: PublicationEvents) => {
	const INITIAL_START_VALUE = 0;
	return atom.pages
		.map((page) => page.events[key])
		.reduce((previousValue: number, currentValue: number) =>
			previousValue + currentValue, INITIAL_START_VALUE);
};